<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a>Contents</h2>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="toc1"> </p></td>
<td valign="top"><p class="toc1"><span href="#/html/cover" title="Link target outside of Sample">Cover</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc1"> </p></td>
<td valign="top"><p class="toc1"><span href="#/html/9780226319094_03_cpy" title="Link target outside of Sample">Copyright</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc1"> </p></td>
<td valign="top"><p class="toc1"><a href="#/html/9780226319094_06_for#for">Foreword</a></p>
<p class="toc-aut">James Druckman</p></td>
</tr>
<tr>
<td valign="top"><p class="toc1"> </p></td>
<td valign="top"><p class="toc1"><a href="#/html/9780226319094_07_ack#ack">Acknowledgments</a></p></td>
</tr>
<tr>
<td valign="top"><p class="toc1"> </p></td>
<td valign="top"><p class="toc1"><a href="#/html/9780226319094_08_int#int">Introduction</a></p>
<p class="toc-aut">Peter K. Hatemi and Rose McDermott</p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><a href="#/html/9780226319094_09_ch01#ch1"><span class="big">1</span></a></p></td>
<td valign="top"><p class="toc"><a href="#/html/9780226319094_09_ch01#ch1">Evolution as a Theory for Political Behavior</a></p>
<p class="toc-aut">Peter K. Hatemi and Rose McDermott</p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/html/9780226319094_10_ch02#ch2" title="Link target outside of Sample"><span class="big">2</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_10_ch02#ch2" title="Link target outside of Sample">Political Primates: What Other Primates Can Tell Us about the Evolutionary Roots of Our Own Political Behavior</span></p>
<p class="toc-aut">Darby Proctor and Sarah Brosnan</p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/html/9780226319094_11_ch03#ch3" title="Link target outside of Sample"><span class="big">3</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_11_ch03#ch3" title="Link target outside of Sample">Formal Evolutionary Modeling for Political Scientists</span></p>
<p class="toc-aut">Oleg Smirnov and Tim Johnson</p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/html/9780226319094_12_ch04#ch4" title="Link target outside of Sample"><span class="big">4</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_12_ch04#ch4" title="Link target outside of Sample">Modeling the Cultural and Biological Inheritance of Social and Political Behavior in Twins and Nuclear Families</span></p>
<p class="toc-aut">Lindon J. Eaves, Peter K. Hatemi, Andrew C. Heath, and Nicholas G. Martin</p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/html/9780226319094_13_ch05#ch5" title="Link target outside of Sample"><span class="big">5</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_13_ch05#ch5" title="Link target outside of Sample">Gene-Environment Interplay for the Study of Political Behaviors</span></p>
<p class="toc-aut">Jason D. Boardman</p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/html/9780226319094_14_ch06#ch6" title="Link target outside of Sample"><span class="big">6</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_14_ch06#ch6" title="Link target outside of Sample">Genes, Games, and Political Participation</span></p>
<p class="toc-aut">James H. Fowler, Peter J. Loewen, Jaime Settle, and Christopher T. Dawes</p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/html/9780226319094_15_ch07#ch7" title="Link target outside of Sample"><span class="big">7</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_15_ch07#ch7" title="Link target outside of Sample">The Mind-Body Connection: Psychophysiology as an Approach to Studying Political Attitudes and Behaviors</span></p>
<p class="toc-aut">Kevin B. Smith and John R. Hibbing</p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><span href="#/html/9780226319094_16_ch08#ch8" title="Link target outside of Sample"><span class="big">8</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_16_ch08#ch8" title="Link target outside of Sample">Hormones and Politics</span></p>
<p class="toc-aut">Rose McDermott</p></td>
</tr>
<tr>
<td valign="top"><p class="toca"><a id="page_viii"></a><span href="#/html/9780226319094_17_ch09#ch9" title="Link target outside of Sample"><span class="big">9</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_17_ch09#ch9" title="Link target outside of Sample">Testosterone and the Biology of Politics: Experimental Evidence from the 2008 Presidential Election</span></p>
<p class="toc-aut">Coren L. Apicella and David A. Cesarini</p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_18_ch10#ch10" title="Link target outside of Sample"><span class="big">10</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_18_ch10#ch10" title="Link target outside of Sample">From SCAN to Neuropolitics</span></p>
<p class="toc-aut">Darren Schreiber</p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_19_ch11#ch11" title="Link target outside of Sample"><span class="big">11</span></span></p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_19_ch11#ch11" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-aut">Peter K. Hatemi and Rose McDermott</p></td>
</tr>
<tr>
<td valign="top"><p class="toc1"> </p></td>
<td valign="top"><p class="toc"><span href="#/html/9780226319094_20_ind#ind" title="Link target outside of Sample">Index</span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226319094_05_toc.vue?0f83e140